interface TimeSlotGroupProps {
	children: React.ReactNode;
	label: string;
	suffix: string | null;
}

export default function TimeSlotGroup({ children, label, suffix }: TimeSlotGroupProps) {
	return (
		<div className="time-slot-group">
			<span className="time-slot-group__label">
				{label}
				{suffix && <b>{suffix}</b>}
			</span>
			<ul className="time-slot-group__list">{children}</ul>
		</div>
	);
}
